import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPaper, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';

export const Layout = () => {
  const { onSubmit, saving } = useMetaLayoutContext();

  return (
    <FDPaper appearance={'flat'} padding={400} width={'100%'}>
      <FDStack direction={'column'} spacing={2}>
        <MetaControlField attr={'scenarioName'} />
        <FDInputRow>
          <MetaControlField attr={'expenseReconsiderationAmount'} />
        </FDInputRow>
        <MetaLayoutRemainingFields />
        <FDStack justifyContent={'flex-end'} spacing={2}>
          <FDPrimaryActionButton
            loading={saving}
            onClick={() => onSubmit()}
            label={'Save Changes'}
          />
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};
